import { Alert, Button, Card, Col, Form, Row, Spinner } from "react-bootstrap";
import {
  FormattedItem,
  IBranchUsersQuery,
  IFormattedUsersJSON,
  convertArrayToJSON,
  formatUsersList,
} from "../../DodavanjeKorisnika/DodavanjeKorisnika/DodavanjeKorisnika";
import {
  GET_BRANCHES_BY_USER,
  GET_BRANCH_USERS,
} from "../../../graphql/dodavanjekorisnika";
import { IAddress, ILocalStorage } from "../../../redux/interfaces";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

import { GET_RECORD_POINT_TREES } from "../../../graphql/tackeprimjene";
import { ListaKompanijaResourcesBSInterface } from "./ListaKompanija.resources";
import Select from "react-select";
import classNames from "classnames";
import { paths } from "../../../routes/paths";
import { useForm } from "react-hook-form";
import { useQuery } from "@apollo/client";
import { useTypedResource } from "../../../i18n/languagehandler";

// Define the form data type
type FormData = {
  branch: BranchOption;
};

// Define the type for the selected option
export type BranchOption = {
  label: string;
  value: string;
};

export interface IBranchesQuery {
  findBranchesByUserId: IBranchElement[];
}

export interface IBranchElement {
  branchId: number;
  name: string;
  address: IAddress;
}

export interface ItemType {
  label: string;
  icon?: string;
  isTitle?: boolean;
  level?: number;
  className?: string;
  children?: Array<ItemType>;
}

// Function to convert FormattedItem to ItemType
export const convertToItemType = (item: FormattedItem, level = 0): ItemType => {
  // Map the properties of FormattedItem to ItemType
  const itemType: ItemType = {
    label: item.text,
    // You can set a default icon or leave it undefined based on your needs
    // icon: 'default_icon',
    // Determine if the item is a title by any specific logic, here assumed false
    isTitle: false,
    level: level,
    // You can set a default className or derive it from the item properties
    // className: 'default_class',
    children: item.children?.map((child) =>
      convertToItemType(child, level + 1)
    ),
  };
  return itemType;
};

export const SiteMapMenuItem = ({ item }: { item: ItemType }) => {
  const { children } = item;
  const hasChildren = item && children && children.length;

  return (
    <li>
      <Link to="#" className={classNames(item.className)}>
        {item.icon && <i className={classNames(item.icon, "me-1")}></i>}
        {item.label}
      </Link>
      {hasChildren && <SiteMapMenu item={item} />}
    </li>
  );
};

export const SiteMapMenu = ({ item }: { item: ItemType }) => {
  return (
    <ul>
      {(item.children || []).map((item, index) => (
        <SiteMapMenuItem key={index} item={item} />
      ))}
    </ul>
  );
};

interface RecordPointTreeTP {
  recordPointTreeId: number;
  createdAt: string;
  updatedAt: string;
  status: boolean;
  name: string;
  parent: string | null; // If nullable in the server schema
  orderNumber: number;
}

interface IRecordPointTreesTP {
  recordPointTrees: RecordPointTreeTP[];
}

interface IRecordPointTreesJSONTP {
  TackePrimjene: TackePrimjene[];
}

interface TackePrimjene {
  Id: number;
  NazivTacke: string;
  Parent: string;
  Order: string;
  Checked: boolean;
}

function convertArrayToJSONTP(arr: any[]): IRecordPointTreesJSONTP {
  const convertedArray: TackePrimjene[] = arr.map((item) => ({
    Id: item.recordPointTreeId,
    NazivTacke: item.name,
    Parent: item.parent, // Assuming there is a property named "parentId" in the object
    Order: item.orderNumber, // Assuming there is a property named "order" in the object
    Checked: false,
  }));

  return { TackePrimjene: convertedArray };
}

interface FormattedItemTP {
  id: number;
  text: string;
  checked: boolean;
  children?: FormattedItemTP[];
}

function formatTackePrimjeneToTreeTP(
  items: TackePrimjene[]
): FormattedItemTP[] {
  const map: { [key: string]: FormattedItemTP } = {};

  // Create a map of TackePrimjene items with their NazivTacke as keys
  for (const item of items) {
    map[item.NazivTacke] = {
      id: item.Id,
      text: item.NazivTacke,
      // checked: checkIfSelected(item.NazivTacke),
      checked: item.Checked,
    };
  }
  // Build the tree structure using the Parent property
  const tree: FormattedItemTP[] = [];
  for (const item of items) {
    const current = map[item.NazivTacke];
    const parent = map[item.Parent || ""];

    if (parent) {
      if (!parent.children) {
        parent.children = [];
      }
      parent.children.push(current);
    } else {
      tree.push(current);
    }
  }

  return tree;
}

function ListaKompanija() {
  const res =
    useTypedResource<ListaKompanijaResourcesBSInterface>("listaKompanija");

  const [branchState, setbranchState] = useState<BranchOption | null>();
  const [categories, setCategories] = useState<BranchOption[]>([]);
  const [branchIdState, setbranchIdState] = useState<string | null>();
  // const [branches, setBranches] = useState<IBranchesQuery>();
  const navigate = useNavigate();

  const storedUser = localStorage.getItem("user");
  let person: ILocalStorage | null = null;
  if (storedUser) {
    person = JSON.parse(storedUser);
  }

  useEffect(() => {
    if (person && person?.user.lastLogin === null) {
      navigate(paths.auth.firstLogin);
    }
  }, [person, navigate]);

  const {
    loading: rpLoading,
    refetch: rpRefetch,
    data: rpData,
    error: rpError,
  } = useQuery<IRecordPointTreesTP>(GET_RECORD_POINT_TREES, {
    variables: {
      branchId: branchIdState ? branchIdState && parseInt(branchIdState) : 0,
    },
    skip: !branchIdState,
  });

  useEffect(() => {
    rpRefetch();

    if (!rpLoading && rpData) {
      if (rpData.recordPointTrees.length === 0) {
      } else {
        const jsonData: IRecordPointTreesJSONTP = convertArrayToJSONTP(
          rpData.recordPointTrees
        );

        const formattedItems: FormattedItemTP[] = formatTackePrimjeneToTreeTP(
          jsonData.TackePrimjene
        );

        const itemTypes: ItemType[] = formattedItems.map((item) =>
          convertToItemType(item)
        );

        const xItem: ItemType = {
          label: "Lista definisanih tacaka",
          children: itemTypes,
        };
        setItemsTP(xItem);
      }
    }
  }, [rpLoading, rpData, rpRefetch]);

  const {
    loading: queryLoading,
    refetch: queryRefetch,
    data: queryData,
    error: errorData,
  } = useQuery<IBranchesQuery>(GET_BRANCHES_BY_USER, {
    variables: { userId: Number(person?.user.userId) },
    skip: person?.user.userId === 0, // Skip query if companyId is 0
    // onCompleted: (data) => {
    //   setBranches(data);
    // },
  });

  const { loading, refetch, data } = useQuery<IBranchUsersQuery>(
    GET_BRANCH_USERS,
    {
      variables: {
        branchId: branchIdState ? branchIdState && parseInt(branchIdState) : 0,
      },
      skip: !branchIdState,
    }
  );

  const [items, setItems] = useState<ItemType | undefined>();
  const [itemsTP, setItemsTP] = useState<ItemType | undefined>();
  const [showItems, setShowItems] = useState<boolean>(false);
  const [showItemsTP, setShowItemsTP] = useState<boolean>(false);

  const createCategoriesFromData = (data: IBranchElement[]) => {
    return (
      data &&
      data.map((branch: any) => ({
        value: branch.branchId.toString(),
        label: branch.name,
      }))
    );
  };

  function getListaDefinisanihTacaka(branchId: string) {
    setbranchIdState(branchId);
    setShowItemsTP(true);
    setShowItems(false);
    rpRefetch({
      branchId: Number(branchId),
    }).catch((error) => {
      // Handle the error case
      console.error(error);
    });
  }

  function getListaDefinisanihRadnihTacaka(branchId: string) {
    setbranchIdState(branchId);
    setShowItemsTP(false);
    setShowItems(true);
    refetch({
      branchId: Number(branchId),
    })
      // .then(({ data }) => {
      //   // Handle the new data if needed
      //   console.log("DATA: ", data);
      // })
      .catch((error) => {
        // Handle the error case
        console.error(error);
      });
  }

  useEffect(() => {
    queryRefetch();

    if (!queryLoading && queryData) {
      const newCategories = createCategoriesFromData(
        queryData.findBranchesByUserId
      );
      setCategories(newCategories);

      // Auto-select first item if no selection exists
      if (newCategories.length > 0 && !branchState) {
        setbranchState(newCategories[0]);
      }
    }
  }, [queryLoading, queryData, queryRefetch, branchState]);

  useEffect(() => {
    refetch();
    if (!loading && data) {
      if (data.branchUsers && data.branchUsers.length === 0) {
      } else {
        const jsonData: IFormattedUsersJSON = convertArrayToJSON(
          data.branchUsers ? data.branchUsers : []
        );

        const formattedItems: FormattedItem[] = formatUsersList(
          jsonData.Positions
        );

        const itemTypes: ItemType[] = formattedItems.map((item) =>
          convertToItemType(item)
        );

        const xItem: ItemType = {
          label: "Lista definisanih tacaka",
          children: itemTypes,
        };
        setItems(xItem);
      }
    }
  }, [loading, data, refetch]);

  const { register, handleSubmit } = useForm<FormData>();

  const onSubmit = (data: FormData) => {};

  function handlebranchChange(value: null | BranchOption) {
    setbranchState(value);
  }

  return (
    <>
      <Row className="mt-2">
        <Col>
          <Card>
            <Card.Body>
              <div
                style={{
                  justifyContent: "center",
                  alignItems: "center",
                  display: "flex",
                }}
              >
                <h1>{res.title}</h1>
              </div>
              <Row>
                {/* Label, Select branch, Button - Add branch */}
                {loading ? (
                  <>
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </>
                ) : (
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <Col xs={12} md={6}>
                      <Form.Group className="mb-3">
                        <Select
                          className="react-select react-select-container"
                          classNamePrefix="react-select"
                          options={categories}
                          id="product-category"
                          placeholder={res.branch.placeholder}
                          type="text"
                          {...register("branch")}
                          name="branch"
                          value={branchState}
                          onChange={(value) => {
                            handlebranchChange(value);
                          }}
                          noOptionsMessage={() => res.branch.notFound}
                        />
                      </Form.Group>
                    </Col>
                    {(errorData || rpError) && (
                      <Alert variant="danger" className="my-2">
                        {res.errorBranches}
                      </Alert>
                    )}
                  </form>
                )}
              </Row>
              <Row>
                {branchState && (
                  <>
                    <Button
                      variant="info"
                      className="rounded-pill waves-effect waves-light mb-2 mx-2"
                      type="button"
                      onClick={() =>
                        getListaDefinisanihTacaka(branchState.value)
                      }
                      style={{ width: "200px" }}
                    >
                      {res.listaTacaka}
                    </Button>

                    <Button
                      variant="info"
                      className="rounded-pill waves-effect waves-light mb-2 mx-2"
                      type="button"
                      onClick={() =>
                        getListaDefinisanihRadnihTacaka(branchState.value)
                      }
                      style={{ width: "200px" }}
                    >
                      {res.listaRadnihTacaka}
                    </Button>
                  </>
                )}
              </Row>
              <Row>
                <ul className="sitemap">
                  <li>
                    {itemsTP && showItemsTP && <SiteMapMenu item={itemsTP} />}
                  </li>
                  <li>{items && showItems && <SiteMapMenu item={items} />}</li>
                </ul>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
}

export default ListaKompanija;
